import Api from '@/services/Api'

export default {

    fetchlut () {
        return Api().get('fetchlut')
    },

    entryNum () {
        return Api().get('entryNum')
    },

    search (search_param, table) {
        return Api().get('searchDB', {
            params: {
                search: search_param,
                table: table
            }
        })
    },

    getMetadata (id, table) {
        return Api().get('searchMetadata', {
            params: {
                id: id,
                table: table
            }
        })
    }

}